
(() => {
  'use strict';
  const KEY = 'bedonmini-wishlist-v1';
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const words = isEnglish ? {
    fav:'My favourites', add:'Add to favourites', remove:'Remove from favourites',
    close:'Close', empty:'No favourites yet.', note:'Favourites are saved on this device only. Adding an item does not reserve it.',
    show:'View product'
  } : {
    fav:'Mes favoris', add:'Ajouter aux favoris', remove:'Retirer des favoris',
    close:'Fermer', empty:'Aucun favori pour le moment.', note:'Les favoris sont enregistrés sur cet appareil seulement. Ils ne réservent pas les articles.',
    show:'Voir le vêtement'
  };
  const heart = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  let saved = [];
  let opener = null;
  let backdrop, drawer, list, counter;
  function productPath(raw) {
    try {
      const url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin) return '';
      if (!/\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      return url.pathname;
    } catch (_e) { return ''; }
  }
  function imageUrl(raw) {
    if (!raw) return '';
    try {
      const url = new URL(raw, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (_e) { return ''; }
  }
  function load() {
    try {
      const arr = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(arr) ? arr.filter(x => x && productPath(x.url) && typeof x.title === 'string').slice(0,80).map(x => ({
        url:productPath(x.url), title:x.title.slice(0,240), image:imageUrl(x.image)
      })) : [];
    } catch (_e) { return []; }
  }
  function persist() {
    try { window.localStorage.setItem(KEY, JSON.stringify(saved)); } catch (_e) {}
  }
  saved = load();
  function getProductFromCard(wrapper) {
    const link = wrapper.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"]');
    if (!link) return null;
    const url = productPath(link.href);
    const title = link.textContent.trim();
    if (!url || !title) return null;
    const img = wrapper.querySelector('.card__media img, .card__inner img');
    return { url, title, image:img ? imageUrl(img.currentSrc || img.getAttribute('src')) : '' };
  }
  function getProductFromPage(info) {
    const url = productPath(window.location.pathname);
    const title = info.querySelector('.product__title h1')?.textContent.trim();
    if (!url || !title) return null;
    const img = info.querySelector('.product__media img, product-media-gallery img');
    return {url, title, image:img ? imageUrl(img.currentSrc || img.getAttribute('src')) : '' };
  }
  function isSaved(url) { return saved.some(x => x.url === url); }
  function updateButtons() {
    document.querySelectorAll('.bm-wishlist-toggle[data-fav-url]').forEach(btn => {
      const active = isSaved(btn.dataset.favUrl);
      btn.classList.toggle('is-selected', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? words.remove : words.add);
      btn.title = active ? words.remove : words.add;
      const label = btn.querySelector('.bm-wishlist-detail-label');
      if (label) label.textContent = active ? words.remove : words.add;
    });
    if (counter) { counter.textContent = String(saved.length); counter.hidden = saved.length === 0; }
  }
  function change(product) {
    const idx = saved.findIndex(x => x.url === product.url);
    if (idx >= 0) saved.splice(idx,1);
    else saved.unshift(product);
    saved = saved.slice(0,80);
    persist(); updateButtons(); render();
  }
  function makeButton(product, detail) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bm-wishlist-toggle' + (detail ? ' bm-wishlist-detail' : '');
    btn.dataset.favUrl = product.url;
    btn.innerHTML = heart;
    if (detail) {
      const span = document.createElement('span');
      span.className = 'bm-wishlist-detail-label';
      btn.appendChild(span);
    }
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      change(product);
    });
    return btn;
  }
  function scan() {
    document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
      const inner = wrapper.querySelector('.card__inner');
      if (!inner || inner.querySelector('.bm-wishlist-toggle')) return;
      const data = getProductFromCard(wrapper);
      if (data) inner.appendChild(makeButton(data,false));
    });
    document.querySelectorAll('product-info[data-product-id]').forEach(info => {
      const heading = info.querySelector('.product__title');
      if (!heading || heading.querySelector('.bm-wishlist-detail')) return;
      const data = getProductFromPage(info);
      if (data) heading.appendChild(makeButton(data,true));
    });
    updateButtons();
  }
  function element(tag,cls,text) {
    const el=document.createElement(tag);
    if (cls) el.className=cls;
    if (text !== undefined) el.textContent=text;
    return el;
  }
  function render() {
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) { list.appendChild(element('p','bm-wishlist-empty',words.empty)); return; }
    saved.forEach(item => {
      const row=element('div','bm-wishlist-item');
      if (item.image) {
        const img=element('img','bm-wishlist-image');
        img.src=item.image; img.alt=''; img.loading='lazy'; row.appendChild(img);
      } else { row.appendChild(element('div','bm-wishlist-image')); }
      const body=element('div','bm-wishlist-product');
      const link=element('a','',item.title);
      link.href=item.url; link.title=words.show;
      body.appendChild(link);
      const remove=element('button','bm-wishlist-remove',words.remove);
      remove.type='button';
      remove.addEventListener('click',()=>{ saved=saved.filter(x=>x.url!==item.url); persist(); updateButtons();render();});
      body.appendChild(remove);row.appendChild(body);list.appendChild(row);
    });
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; backdrop.hidden=true;
    document.body.classList.remove('bm-wishlist-is-open');
    if (opener && opener.isConnected) opener.focus();
  }
  function open() {
    if (!drawer) return;
    opener=document.activeElement;
    render();
    drawer.hidden=false; backdrop.hidden=false;
    document.body.classList.add('bm-wishlist-is-open');
    drawer.querySelector('.bm-wishlist-close').focus();
  }
  function setup() {
    if (!document.body || document.querySelector('.bm-wishlist-drawer')) return;
    const cart=document.getElementById('cart-icon-bubble');
    if (cart) {
      const trigger=element('button','header__icon bm-wishlist-header');
      trigger.type='button';trigger.setAttribute('aria-label',words.fav);trigger.title=words.fav;
      trigger.innerHTML=heart;
      counter=element('span','bm-wishlist-count');
      trigger.appendChild(counter);
      cart.parentNode.insertBefore(trigger,cart);
      trigger.addEventListener('click',open);
    }
    backdrop=element('div','bm-wishlist-backdrop');
    backdrop.hidden=true;
    backdrop.addEventListener('click',close);
    drawer=element('aside','bm-wishlist-drawer');
    drawer.hidden=true;
    drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');
    drawer.setAttribute('aria-label',words.fav);
    const top=element('div','bm-wishlist-drawer-header');
    top.appendChild(element('h2','bm-wishlist-drawer-title',words.fav));
    const x=element('button','bm-wishlist-close','×');
    x.type='button';x.setAttribute('aria-label',words.close);x.addEventListener('click',close);
    top.appendChild(x); drawer.appendChild(top);
    drawer.appendChild(element('p','bm-wishlist-note',words.note));
    list=element('div','bm-wishlist-list');
    drawer.appendChild(list);
    document.body.append(backdrop,drawer);
    drawer.addEventListener('keydown', event => {
      if (event.key === 'Escape') {event.preventDefault();close();}
      if (event.key !== 'Tab') return;
      const all=Array.from(drawer.querySelectorAll('button:not([disabled]),a[href]'));
      if (!all.length) return;
      if (event.shiftKey && document.activeElement===all[0]) {event.preventDefault();all[all.length-1].focus();}
      else if (!event.shiftKey && document.activeElement===all[all.length-1]) {event.preventDefault();all[0].focus();}
    });
    scan();
    let queued=false;
    const observer=new MutationObserver(()=>{
      if (queued) return;
      queued=true;
      requestAnimationFrame(()=>{queued=false;scan();});
    });
    observer.observe(document.body,{subtree:true,childList:true});
    window.addEventListener('storage',event=>{if (event.key===KEY) {saved=load();updateButtons();render();}});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
})();
